/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_DisclaimerInputs */



/**
* | output |
* | --- |
* | "Wundo can make mistakes. Check important info." |
*
* @param {Chat_DisclaimerInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_disclaimer = /** @type {((inputs?: Chat_DisclaimerInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_DisclaimerInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo kan fouten maken. Controleer belangrijke info.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo peut se tromper. Vérifiez les infos importantes.")
	return /** @type {LocalizedString} */ ("Wundo can make mistakes. Check important info.")
});